"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionCreators = {
    deleteAuthentication: function () { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.authentication) {
            fetch("/v1/auth", {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('FOCUSONE_API_GATEWAY'),
                },
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                localStorage.clear();
                dispatch({ type: 'RECEIVE_DEAUTHENTITION', response: data });
            })
                .catch(function (error) {
                dispatch({ type: 'RECEIVE_DEAUTHENTITION', response: error });
            });
            dispatch({ type: 'REQUEST_DEAUTHENTITION' });
        }
    }; }
};
var unloadedState = { isLoading: false };
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_DEAUTHENTITION':
            return {
                response: state.response,
                isLoading: true
            };
        case 'RECEIVE_DEAUTHENTITION':
            return {
                response: action.response,
                isLoading: false
            };
        default:
            return state;
    }
};
//# sourceMappingURL=DeAuthentication.js.map